import { SessionSyncStatus } from '../../../components/SessionSyncStatus';
import { FiRefreshCw } from 'react-icons/fi';
import Button from '../../../components/ui/Button';

/**
 * The sticky session actions bar: sync status, inspected-progress readout, and
 * the Finish Session button. Extracted verbatim from TestSessionView.
 */
export function SessionActionsBar({ isSessionActive, inspectedCount, totalCount, isSyncing, onFinish }) {
  return (
    <div className="session-actions-bar mobile-sticky-actions">
      <div className="session-actions session-actions-inner">
        <SessionSyncStatus />
        {isSessionActive ? (
          <span className="session-actions-progress" aria-live="polite">
            TOTAL INSPECTED {inspectedCount}
            {` / ${totalCount}`}
          </span>
        ) : (
          <span className="session-actions-progress text-muted" aria-live="polite">
            Select an asset type above to begin testing
          </span>
        )}
        {/* Cancel Session: options menu (⋯) only — avoids duplicate beside Finish */}
        <Button
          type="button"
          variant="primary"
          className="session-actions-finish-btn"
          onClick={onFinish}
          disabled={isSyncing}
        >
          {isSyncing ? (
            <FiRefreshCw style={{ marginRight: '8px' }} className="animate-spin" />
          ) : null}{' '}
          Finish Session
        </Button>
      </div>
    </div>
  );
}
